import { AbstractCommand } from 'src/models/command';

class DocumentDeleteByAggregateIdCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_Document_DeleteDocument';

	public constructor(aggregateId: string, aggregateVersion: number, processId: string) {
		super();
		this.processId = processId;
		this.parameters = {
			aggregateId: aggregateId,
			aggregateVersion: aggregateVersion,
		};
	}
}

export { DocumentDeleteByAggregateIdCommand };
